import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCashDay } from "../../../../services/cashBookApi";
import { useKT } from "../../i18n/kt";
import { kp } from "../../karkhanaPaths";
import type { MissingItem } from "../types";

/** Which line the strip says: a missing pay sheet comes first, then a missing spends page. */
export const stripText = (missing: MissingItem[]): string | null => {
  if (missing.some((m) => m.kind === "PAY_SHEET")) return "Pay sheet to send · Cash";
  if (missing.some((m) => m.kind === "SPENDS")) return "Spends page to send · Cash";
  return null;
};

/**
 * Orange strip above रोज़ का काम when a photo is missing and it is reminder time (V1_SPEC E2, D21:
 * from 19:00 IST on the day, and the next morning). The whole strip opens नकद. Never blocks work.
 */
const ReminderStrip = () => {
  const { t } = useKT();
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    getCashDay()
      .then((res) => {
        if (!live || !res?.success || !res.data?.reminder) return;
        setText(stripText(res.data.missing || []));
      })
      .catch(() => undefined); // No network: the red dot on नकद still shows; the strip waits.
    return () => {
      live = false;
    };
  }, []);
  if (!text) return null;
  return (
    <Link to={kp.cashBook()} className="kf-strip" role="status">
      <span>{t(text)}</span>
      <span aria-hidden="true">›</span>
    </Link>
  );
};

export default ReminderStrip;
